<template>
    <div class="newbie_guide_item">
        <div class="main">
            <van-image
                :src="item"
                width="80vw"
                height="80vh"
                fit="contain"
            ></van-image>
        </div>
    </div>
</template>
<script>
export default {
    name: "newbieGuideItem",
    props: ['item']
}
</script>

<style scoped>
    .newbie_guide_item { padding-top: 20px; }
    .content {
        /*padding: 0 10vw;*/
        text-align: center;
        display: flex;
        justify-content: center;
    }
    /*.content .content_img {*/
    /*    !*max-width: 100%;*!*/
    /*    width: 80vw;*/
    /*    max-width: 500px;*/
    /*    max-height: 500px;*/
    /*    object-fit: contain;*/
    /*    vertical-align: middle;*/
    /*    border-radius: 1.87vw;*/
    /*}*/
    /*.arrow {*/
    /*    padding-top: 2.26vw;*/
    /*    text-align: center;*/
    /*}*/
    /*.arrow .arrow_icon {*/
    /*    width: 4.67vw;*/
    /*    vertical-align: middle;*/
    /*    object-fit: contain;*/
    /*}*/
    /*.explain {*/
    /*    text-align: center;*/
    /*    color: #fff;*/
    /*}*/
    /*.explain .explain_title {*/
    /*    font-size: 4.53vw;*/
    /*    font-weight: 500;*/
    /*    color: #FFF;*/
    /*    line-height: 6.4vw;*/
    /*    margin: 2.27vw 0 1.33vw;*/
    /*}*/
    /*.explain .explain_desc {*/
    /*    font-size: 3.2vw;*/
    /*    font-weight: 400;*/
    /*    color: #E4E5E6;*/
    /*    line-height: 4.4vw;*/
    /*    margin: 0;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/newbieGuide/newbieGuideItem.vue